import axios from 'axios';

// Base API configuration
const API_BASE_URL = 'http://localhost:8080/api';

// Create axios instance for auth services
const authAPI = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth Service Class
class AuthService {
  // Login user
  async login(credentials) {
    try {
      const response = await authAPI.post('/auth/signin', credentials);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Login failed'
      };
    }
  }

  // Register user
  async register(userData) {
    try {
      const response = await authAPI.post('/auth/signup', userData);
      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Registration failed'
      };
    }
  }

  // Refresh token
  async refreshToken() {
    try {
      const token = this.getToken();
      if (!token) {
        throw new Error('No token available');
      }

      const response = await authAPI.post('/auth/refresh', {}, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Token refresh failed'
      };
    }
  }

  // Store token in localStorage
  setToken(token) {
    if (token) {
      localStorage.setItem('jwt_token', token);
    }
  }

  // Get token from localStorage
  getToken() {
    return localStorage.getItem('jwt_token');
  }

  // Remove token from localStorage
  removeToken() {
    localStorage.removeItem('jwt_token');
  }

  // Store user data in localStorage
  setUser(user) {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    }
  }

  // Get user data from localStorage
  getUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

  // Remove user data from localStorage
  removeUser() {
    localStorage.removeItem('user');
  }

  // Check if user is authenticated
  isAuthenticated() {
    const token = this.getToken();
    const user = this.getUser();
    return !!(token && user);
  }

  // Logout user
  logout() {
    this.removeToken();
    this.removeUser();
    window.location.href = '/login';
  }

  // Get auth headers for API calls
  getAuthHeaders() {
    const token = this.getToken();
    return token ? { 'Authorization': `Bearer ${token}` } : {};
  }
}

// Create and export a single instance
const authService = new AuthService();
export default authService;